import { MapPin, Compass, Tractor } from "lucide-react";
import { cn } from "@/lib/utils";

export type ExploreMode = "places" | "do" | "farms";

interface ExploreModeToggleProps {
  mode: ExploreMode;
  onModeChange: (mode: ExploreMode) => void;
}

const MODES: { key: ExploreMode; label: string; icon: React.ElementType }[] = [
  { key: "places", label: "Platser", icon: MapPin },
  { key: "do", label: "Göra", icon: Compass },
  { key: "farms", label: "Gårdar", icon: Tractor },
];

/**
 * Desktop/tablet mode toggle — rendered as tabs at top of page.
 * Hidden on mobile where ExploreFooterNav is used instead.
 */
const ExploreModeToggle = ({ mode, onModeChange }: ExploreModeToggleProps) => {
  return (
    <div
      className="flex gap-1 overflow-x-auto scrollbar-hide pb-0.5"
      role="tablist"
      aria-label="Explore-läge"
    >
      {MODES.map(({ key, label, icon: Icon }) => (
        <button
          key={key}
          onClick={() => onModeChange(key)}
          role="tab"
          aria-selected={mode === key}
          className={cn(
            "shrink-0 flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 min-h-[40px]",
            mode === key
              ? "bg-primary text-primary-foreground shadow-sm"
              : "bg-muted/50 text-muted-foreground hover:bg-muted hover:text-foreground"
          )}
        >
          <Icon className="h-3.5 w-3.5" />
          {label}
        </button>
      ))}
    </div>
  );
};

export default ExploreModeToggle;
